export default __webpack_public_path__ + "static/media/team5.c03d894c.JPG";